import { array, Decoder, object, string } from '@mojotech/json-type-validation'

import { ProblemTag } from '@/domain/entities/problem/problemTag'

export const problemTagDecoder: Decoder<ProblemTag> = object({
  tag: string(),
  users: array(string())
})
